import { createLoadableComponent } from '../../infrastructure/code-splitting/utils/LoadableComponentFactory';
import LoadingAnimation from '../../common/loading/components/LoadingAnimation';

export default createLoadableComponent(() => import('./components/MyBookingsPage'), {
  FallbackComponent: LoadingAnimation,
});

export const TripHistory = createLoadableComponent(
  () => import('./components/TripHistoryRoutePage'),
  {
    FallbackComponent: LoadingAnimation,
  },
);
